export const filterTranslations = {
  'above-deck-mixer': [
    'Above Deck Mixer',
    'Mezcladora Sobre la Cubierta',
    '台上混水阀'
  ],
  'aerated-installed-or-laminar-in-box': [
    'Aerated (installed) or Laminar (in box)',
    'Aerated (installed) or Laminar (in box)',
    '起泡式（需安装）或层流式（盒装）'
  ],
  aerated: [
    'Aerated',
    'Aereado',
    '起泡式'
  ],
  'back-check-tee': [
    'Back-Check Tee',
    'Back-Check en Te',
    '三通止回阀'
  ],
  'battery-with-hardwired-option': [
    'Battery with Hardwired Option',
    'Battery with Hardwired Option',
    '电池供电，可选固定连接'
  ],
  battery: [
    'Battery',
    'Baterías',
    '电池供电'
  ],
  'below-deck-manual-mixing-valve': [
    'Below Deck Manual Mixing Valve',
    'Válvula Mezcladora Manual Bajo la Cubierta',
    '台下手动混水阀'
  ],
  'below-deck-thermostatic-mixing-valve': [
    'Below Deck Thermostatic Mixing Valve',
    'Válvula Mezcladora Termostática Bajo la Cubierta',
    '台下恒温混水阀'
  ],
  concealed: [
    'Concealed',
    'Oculta',
    '明装式'
  ],
  exposed: [
    'Exposed',
    'Expuesta',
    '暗装式'
  ],
  hardwired: [
    'Hardwired',
    'Cableado',
    '固定连线'
  ],
  'integrated-side-mixer': [
    'Integrated Side Mixer',
    'Mezcladora Lateral Integrada',
    '集成式侧边混水阀'
  ],
  laminar: [
    'Laminar',
    'Laminar',
    '层流式'
  ],
  'multi-laminar': [
    'Multi-Laminar',
    'Multi-Laminar',
    '多层流式'
  ],
  none: [
    'Mixer Not Included',
    'No Incluida',
    '不提供混水阀'
  ],
  'service-sink': [
    'Service Sink',
    'Lavabo de Servicio',
    '拖把池'
  ],
  'shower-head': [
    'Shower Head',
    'Cebolleta',
    '淋浴喷头'
  ],
  solar: [
    'Solar',
    'Solar',
    '光能'
  ],
  turbine: [
    'Turbine',
    'Turbine',
    '涡轮'
  ],
  urinal: [
    'Urinal',
    'Mingitorio',
    '小便池'
  ],
  'water-closet': [
    'Water Closet',
    'Sanitario',
    '座便器'
  ]
};
